import { Navigate } from "react-router-dom";
import ListView from "../../../components/listView/ListView";
import Page from "../../../components/pageView/Page";
import WidgetPage from "../../../components/widgetPage/WidgetPage";
import AccountBalancePage from "../../../pages/apps/accounting/AccountBalancePage";
import AccountingSettingsPage from "../../../pages/apps/accounting/AccountingSettingsPage";
import PostingStatusPage from "../../../pages/apps/accounting/PostingStatusPage";
import VatReturnPage from "../../../pages/apps/accounting/VatReturnPage";

const routesAccounting = [
  {
    path: "/accounting",
    element: WidgetPage,
    props: {
      type: "accounting",
      draggable: false,
      resizable: false,
    },
  },
  {
    path: "/accounting/journal",
    element: ListView,
    props: { type: "journalList" },
  },
  {
    path: "/accounting/journal/:id",
    element: Page,
    props: {
      type: "journalPage",
      options: { mode: "edit", load: true },
    },
  },
  {
    path: "/accounting/journal/new",
    element: Page,
    props: {
      type: "journalPage",
      options: { mode: "new", load: false },
    },
  },
  // The same journals, entered in a grid: one row per line, Tab to move on.
  {
    path: "/accounting/fast-journal",
    element: ListView,
    props: { type: "fastJournalList" },
  },
  {
    path: "/accounting/fast-journal/:id",
    element: Page,
    props: {
      type: "fastJournalPage",
      options: { mode: "edit", load: true },
    },
  },
  {
    path: "/accounting/fast-journal/new",
    element: Page,
    props: {
      type: "fastJournalPage",
      options: { mode: "new", load: false },
    },
  },
  {
    path: "/accounting/balance",
    element: AccountBalancePage,
    props: {},
  },
  {
    path: "/accounting/vat-return",
    element: VatReturnPage,
    props: {},
  },
  {
    path: "/accounting/posting-status",
    element: PostingStatusPage,
    props: {},
  },
  {
    path: "/accounting/settings",
    element: AccountingSettingsPage,
    props: {},
  },
  {
    path: "/accounting/account",
    element: ListView,
    props: { type: "glAccountList" },
  },
  {
    path: "/accounting/account/:id",
    element: Page,
    props: {
      type: "glAccountPage",
      options: { mode: "edit", load: true },
    },
  },
  {
    path: "/accounting/account/new",
    element: Page,
    props: {
      type: "glAccountPage",
      options: { mode: "new", load: false },
    },
  },
  {
    path: "/accounting/period",
    element: ListView,
    props: { type: "accountingPeriodList" },
  },
  {
    path: "/accounting/period/:id",
    element: Page,
    props: {
      type: "accountingPeriodPage",
      options: { mode: "edit", load: true },
    },
  },
  {
    path: "/accounting/period/new",
    element: Page,
    props: {
      type: "accountingPeriodPage",
      options: { mode: "new", load: false },
    },
  },
  {
    path: "/accounting/ledger",
    element: ListView,
    props: { type: "ledgerEntryList" },
  },
  // VAT Rules moved into Accounting › Settings; the old address still works.
  {
    path: "/accounting/vat-rules",
    element: Navigate,
    props: { to: "/accounting/settings", replace: true },
  },
  {
    path: "/accounting/posting-rule",
    element: ListView,
    props: { type: "postingRuleList" },
  },
  {
    path: "/accounting/posting-rule/:id",
    element: Page,
    props: {
      type: "postingRulePage",
      options: { mode: "edit", load: true },
    },
  },
  {
    path: "/accounting/posting-rule/new",
    element: Page,
    props: {
      type: "postingRulePage",
      options: { mode: "new", load: false },
    },
  },
];

export default routesAccounting;
